<template>
    <section id="home">
        <div id="content">
            <section id="header">
                <h1>{{ $t('homepage.title') }}</h1>
            </section>

            <section id="prompt">
                <p>{{ $t('homepage.discover_text') }}</p>
                <router-link :to="{name: 'recipients'}" class="outline-button">{{ $t('homepage.start_button') }}</router-link>
            </section>

            <section id="quote">
                <blockquote>
                    <span class="quote-text">
                        {{ $t('homepage.quote') }}
                    </span>
                    <cite>— {{ $t('homepage.quote_credit') }}</cite>
                </blockquote>
            </section>
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex'
import StyledButton from "@/components/StyledButton"

export default {
    components: {
        StyledButton
    },
        head: {
        title: function() {
            return {
                inner: this.$i18n.t('main.site_name'),
                separator: '|',
                complement: this.$i18n.t('main.museum_name')
            }
        },
        meta: function() {
            return [
                {rel: 'canonical', href: this.$i18n.t('main.cannonical'), id: 'rel-con'},
                {rel: 'alternate', href: this.$i18n.t('main.alternate'), hreflang: this.$i18n.t('main.alternate_locale'), id: 'rel-alt'},

                {name: 'description', content: this.$i18n.t('homepage.discover_text'), id: 'desc'},

                {property: 'og:title', content: `${this.$i18n.t('main.site_name')} | ${this.$i18n.t('main.museum_name')}`, id: 'og-title'},
                {property: 'og:description', content: this.$i18n.t('homepage.discover_text'), id: 'og-desc'},
                {property: 'og:type', content: 'website', id: 'og-type'},
                {property: 'og:locale', content: this.$i18n.locale, id: 'og-locale'},
                {property: 'og:image', content: `${window.location.host}${this.$i18n.t('main.preview_image')}`, id: 'og-image'}
            ]
        }
    }
}
</script>

<style scoped lang="scss">
#home {
    background-color: #14171a;
}

#content {
    padding: 50px;
    padding-top: 100px;
    text-align: center;
    background-image: url("../../public/images/tilston-title-bg-medal.jpg");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: top 20% left 0%;

    section {
        margin: 0 auto;
        padding: 0 20px;
    }
}

#header {
    max-width: 740px;

    h1 {
        font-size: 50px;
        font-family: 'FuturaBold', sans-serif;
        line-height: 60px;
        letter-spacing: 5px;
        text-decoration: none;
        text-transform: uppercase;
        color: #f8f9fa;
    }
}

#prompt {
    max-width: 600px;

    .outline-button {
        $green: #00b74f;
        color: $green;
        border: solid 1px $green;

        font-size: 16px;
        font-family: 'FuturaBold', sans-serif;
        font-weight: bold;
        line-height: 20px;
        text-transform: uppercase;
        font-kerning: none;
        letter-spacing: 4px;
        text-decoration: none;

        padding: 22px 28px 15px 40px;
        display: inline-block;
        margin-top: 30px;

        transition: background-color 250ms ease, border-color 250ms ease;

        &:hover {
            color: #000;
            background-color: $green;
            border-color: $green;

            &:after {
                content: url('../assets/icons/triangle-dark.svg');
            }
        }

        &:after {
            content: url('../assets/icons/triangle.svg');
            width: 25px;
            height: 25px;
            margin-left: 15px;
            margin-top: 3px;
            display: inline-block;
        }
    }
}

p {
  font-size: 18px;
  line-height: 28px;
  font-weight: lighter;
  text-decoration: none;
  color: #f8f9fa;
  font-kerning: none;
}

section#quote {
    max-width: 655px;
    padding: 120px 10px;
    margin-top: 25%;

    blockquote {
        margin: 0;
        text-align: left;
        position: relative;

        .quote-text {
            font-size: 24px;
            line-height: 32px;
            color: #c0c0c0;
            font-style: normal;
            padding-left: 20px;

            &:before {
                content: "“";
                color: #c0c0c0;
                line-height: 32px;
                font-size: 36px;
                position: absolute;
                left: 0px;
                top: 5px;
            }

            &:after {
                content: "”";
                color: #c0c0c0;
                line-height: 32px;
                font-size: 36px;
                position: absolute;
                margin-left: 8px;
            }
        }

        cite {
            text-align: center;
            font-style: normal;
            text-transform: uppercase;
            line-height: 32px;
            font-size: 14px;
            font-weight: 500;
            letter-spacing: 2px;
            color: #c0c0c0;
            display: block;
            margin-left: 0;
            margin-top: 10px;
        }
    }

    img {
        width: 50%;
        max-width: 420px;
    }
}

html[lang="fr"] {
    section#quote blockquote .quote-text {
        &:before {
            content: "«";
            left: -3px;
            top: -4px;
        }

        &:after { content: "»"; }
    }
}

@media screen and (max-width: 1040px) {
    #content section#header {
        h1 {
            margin-bottom: 20px;
        }
    }

}
@media screen and (max-width: 650px) {
    #content {
        padding: 10px;
    }

    #content section#prompt {
        margin-top: 40%;
    }

    #content section#quote {
        margin-top: 0;
        padding-top: 60px;
    }
}
@media screen and (max-width: 800px) {
    #header {
        h1 {
            font-size: 40px;
            line-height: 50px;
        }
    }

    section#quote {
        blockquote {
            width: 80%;
            margin: 40px auto;
        }

        img {
            width: 80%;
            margin: 0 auto;
        }
    }
}

@media screen and (max-width: 520px) {
    section#header {
        padding: 0;

        h1 {
            font-size: 30px;
            line-height: 40px;
        }
    }

    html[lang="fr"] {
        #header h1 {
            font-size: 26px;
            letter-spacing: 2px;
        }
    }
}
</style>
